package com.milta.feature.route.domain.usecase

import com.milta.core.network.PagedResult
import com.milta.feature.route.domain.entity.RouteHistoryItem
import com.milta.feature.route.domain.repository.RouteRepository

/**
 * GET /api/v1/routes/history — MIL-52, paginated route history for the web dashboard's
 * "Historique des tournées" (Screen A).
 */
class GetRouteHistoryUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(
        from: String? = null,
        to: String? = null,
        driverId: String? = null,
        search: String? = null,
        page: Int = 1,
        pageSize: Int = 20,
    ): PagedResult<RouteHistoryItem> = repository.getRouteHistory(from, to, driverId, search, page, pageSize)
}
